// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import './theme/first/index.css'

import store from './store'

import "_i/iconfont.css"
Object.defineProperty(Vue.prototype, '$_has', {
  value: function (access) {
      //超级管理员
      if(store.state.user.userInfo.admin_id==1){
        return true;
      }
      //可访问唯一权限key
      let menu=store.state.user.userInfo.menu
      if(menu.indexOf(access)>=0){
        return true;
      }else{
        return false;
      }
  }
});
Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js